module.exports = __webpack_public_path__ + "img/logo_dark.55b0f071.png";